<template>
  <div class="c-category-list__single qa-category">
    <div class="c-category-list__single__thumb">
      <img class="o-media c-category-list__single__thumb__img" :src="thumb">
    </div>
    <h2 class="c-category-list__single__title t-category-headline">{{ name }}</h2>
    <img class="c-category-list__single__spacer" src="/img/thm350.png">
  </div>
</template>




<script>
import { get, isObject } from 'lodash'
import { mapGetters } from 'vuex'

export default {
  name: 'CategoryListTile',

  props: {
    category: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters([
      'participant'
    ]),

    /**
     * Determine the category name.
     *
     * @return {String}
     */
    name () {
      return isObject(this.category) && isObject(this.category.name)
        ? get(this.category, 'name.' + this.participant.catalog_locale, '')
        : get(this.category, 'name', null)
    },

    /**
     * Determine the category thumbnail image URL.
     *
     * @return {String}
     */
    thumb () {
      return get(this.category, 'images.' + this.participant.catalog_locale + '.0.sizes.350x350') ||
        get(this.category, 'image.url') ||
        '/img/thm350.png'
    }
  }
}
</script>




<style lang="scss" scoped>
  .c-category-list .is-not-linked.c-category-list__single:hover {
    cursor: initial;

    .c-category-list__single__title {
      height: 44px;
    }

    .c-category-list__single__thumb__img {
      height: 100%;
      max-width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// CategoryListTile.vue?303d3d5e